import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=0e4ccf0b&scoped=true&"
import script from "./aboutUs.vue?vue&type=script&lang=ts&"
export * from "./aboutUs.vue?vue&type=script&lang=ts&"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=0e4ccf0b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4ccf0b",
  null
  
)

export default component.exports